// Mirrors the backend's STRONG_PASSWORD_REGEX (trueapp-api-nestjs: common/validators/password-policy.util.ts),
// same rule the admin panel uses
export const STRONG_PASSWORD_REGEX =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*[\d!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]).{6,15}$/;

export const STRONG_PASSWORD_MESSAGE =
  "6-15 characters with an uppercase letter, a lowercase letter, and a number or symbol.";

export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
